import React, { useEffect, useState } from 'react';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import relationships from 'Consts/Relationships';

import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import featureEnabled from 'Helpers/Affordances';
import Button from 'Components/UI/Button';
import { currency } from 'Helpers/Formats';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import { useLocation } from 'react-router';
import LinearProgress from '@material-ui/core/LinearProgress';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
  },
  header: {
    color: theme.palette.facet.primaryBlue,
    marginBottom: theme.spacing(2),
  },
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  progress: {
    width: theme.dimensions.lg,
    margin: theme.spacing(2),
  },
  [theme.breakpoints.down('md')]: {
    progress: {
      width: theme.dimensions.sm,
    },
  },
  smaller: { padding: theme.spacing(0.5) },
}));

export default function EmergencyFund() {
  const classes = useStyles();
  const { householdResource } = useSimpleHousehold();
  const [emergencyFundResource, setEmergencyFundResource] = useState();
  const [progress, setProgress] = useState(0);
  const location = useLocation();

  useEffect(() => {
    if (householdResource) {
      if (!featureEnabled(householdResource, relationships.emergencyFund)) {
        return;
      }
    }

    if (
      householdResource
      && householdResource.relationship(relationships.emergencyFund)
      && householdResource
        .relationship(relationships.emergencyFund)
        .link('related')
    ) {
      householdResource
        .relationship(relationships.emergencyFund)
        .link('related')
        .Get()
        .then((emergencyCollection) => {
          if (emergencyCollection.resources().list().length > 0) {
            setEmergencyFundResource(emergencyCollection.resources().head());
            const prog = (parseFloat(
              emergencyCollection
                .resources()
                .head()
                .attr('currentAmount'),
            )
                / parseFloat(
                  emergencyCollection
                    .resources()
                    .head()
                    .attr('targetAmount'),
                ))
              * 100;
            setProgress(prog < 100 ? prog : 100);
          }
        });
    }
  }, [householdResource, location]);

  const EmergencyLinearProgess = withStyles(theme => ({
    root: {
      height: 10,
      borderRadius: 5,
    },
    colorPrimary: {
      backgroundColor: theme.palette.facet.lightGray,
    },
    bar: {
      borderRadius: 5,
      backgroundColor: theme.palette.facet.accentGreen,
    },
  }))(LinearProgress);

  return (
    <div className={classes.root}>
      <Typography className={classes.header} variant="h3">
        Emergency Fund
      </Typography>
      {emergencyFundResource ? (
        <>
          <Typography variant="body1">
            {'You have '}
            <b>{`${currency(emergencyFundResource.attr('currentAmount'))}`}</b>
            {' set away for your emergency fund'}
          </Typography>
          <div className={classes.progressContainer}>
            <Typography variant="body1">{currency('0')}</Typography>
            <div className={classes.progress}>
              <EmergencyLinearProgess variant="determinate" value={progress} />
            </div>

            <Typography variant="body1">
              {currency(emergencyFundResource.attr('targetAmount'))}
            </Typography>
            <IconButton
              aria-label="edit"
              size="small"
              className={classes.smaller}
              onClick={() => openModal(modalConsts.emergencyFundModal)}
            >
              <EditIcon className={classes.smaller} />
            </IconButton>
          </div>
        </>
      ) : (
        <Button
          variant="contained"
          color="secondary"
          onClick={() => openModal(modalConsts.emergencyFundModal)}
        >
          Set Up an Emergency Fund
        </Button>
      )}
    </div>
  );
}
